export default "__VITE_ASSET__87a654f3__"